import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import PodiatryApp from 'components/podiatry';

function ReasonForVisit() {
  return (
    <IntakeStartScreen
      currentStep="hpi"
      metaTitle="Reason for visit"
    >
      <PodiatryApp />
    </IntakeStartScreen>
  );
}

export default ReasonForVisit;
